module.exports = __webpack_public_path__ + "img/swiper__img3.d093cb54.svg";